// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect[data-v-ff5b8e8a] {\n  min-width: 180px;\n}\n.multiselect.multiselect--status[data-v-ff5b8e8a] {\n  width: 100px;\n  min-width: 100px;\n}", ""]);
// Exports
module.exports = exports;
